export type TrackEventData = {
  paymentIssuerSource: string;
  type: string;
  cardType: string;
  bankEntityCode: string;
  paymentQuantityType: string;
  paymentDayNumber: string;
};
export function makeEmptyTrackEvent(): TrackEventData {
  return {
    paymentIssuerSource: '',
    type: '',
    cardType: '',
    bankEntityCode: '',
    paymentQuantityType: '',
    paymentDayNumber: '',
  };
}
